import { appBaseUrl } from "@/variables"

import { OrderClient } from "@/lib/api"

const initialState = () => ({
    api: new OrderClient(appBaseUrl),
    orders: [],
    checkoutOrder:{ transactionId: "", postDate:"" , paymentId: "", total:"", completedDate:"",id :""},
    externalPaymentUrl:{url:""},
    orderInfo:{}

});

// State object
const state = {
    api: new OrderClient(appBaseUrl),
    orders: [],
    checkoutOrder:{ transactionId: "", postDate:"" , paymentId: "", total:"", completedDate:"",id :""},
    externalPaymentUrl:{url:""},
    orderInfo:{}
}
 
// Getter functions
const getters = {
    getApi(state) {
        return state.api;
    },
    orders(state) {
        return state.orders;
    },
    checkoutOrder(state) {
        return state.checkoutOrder;
    },
    externalPaymentUrl(state) {
        return state.externalPaymentUrl;
    },
    orderInfo(state) {
        return state.orderInfo;
    }
}

// Actions 
const actions = {
    async createOrder({state, commit}){
        const response = await state.api.createOrder()

        commit('createOrderCompleted', response);
    },

    async createOrderWithDedication({state, commit}, {from, to, message, dedicationDesignId}){

        let model = {
            hasDedication: true,
            from: from,
            to: to,
            message: message,
            dedicationDesignId: dedicationDesignId
        };

        const response = await state.api.createOrderWithDedication(model)

        commit('createOrderWithDedicationCompleted', response);
    },

    async loadCheckoutOrder({state, commit}, orderNumber){
        const response = await state.api.orderSummaryByNumber(orderNumber);

        commit('loadCheckoutOrderCompleted', response);
    },
    async loadCheckoutOrderByPaymentInfo({state, commit}, {orderNumber,paymentId,transactionId}){
        const response = await state.api.orderSummaryByPaymentInfo(orderNumber, paymentId, transactionId);
        commit('loadCheckoutOrderCompleted', response);
    },
    async loadOrderInfoByPaymentInfo({state, commit}, {orderNumber,paymentId,transactionId}){
        const response = await state.api.orderDetailByPaymentInfo(orderNumber, paymentId, transactionId);
        commit('loadOrderInfoByPaymentInfoCompleted', response);
    },

    async loadCustomerOrders({state, commit}){
        const response = await state.api.customerOrders();

        commit('loadCustomerOrdersCompleted', response);
    },
   
}

// Mutations
const mutations = {

    createOrderCompleted(state, externalPaymentModel){
        state.externalPaymentUrl = externalPaymentModel;
    },
    createOrderWithDedicationCompleted(state, externalPaymentModel){
        state.externalPaymentUrl = externalPaymentModel;
    },
    loadCheckoutOrderCompleted(state, order){
        state.checkoutOrder = order
    },
    loadOrderInfoByPaymentInfoCompleted(state, order){
        state.checkoutOrder = order;
    },
    loadCustomerOrdersCompleted(state, orders){
        state.orders = orders;
    },

    RESET(state) {
        const newState = initialState();
        Object.keys(newState).forEach(key => {
            state[key] = newState[key]
        });
    },
    loadToken(state){
        //console.log('OrderloadToken');
        let token = window.localStorage.getItem('token') || ""
        //console.log(`Order token:${token}`);
        state.api.instance.defaults.headers.common = {'Authorization': `Bearer ${token}`};
    },

}


export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}